<template>
	<CloHeading level="3" size="4" :href="prefix + href" reverse hiddenLink class="u-stack-sm">
		<slot></slot>
	</CloHeading>
</template>

<script>
import CloHeading from '@/base/CloHeading/CloHeading.vue';
export default {
	name: 'CloFooterListHeading',
	components: { CloHeading },
	props: {
		href: {
			type: String,
			default: '',
		},
		prefix: {
			type: String,
			default: '',
		},
	},
};
</script>

<style lang="scss"></style>
